import { Track } from 'livekit-client';
import { computed, makeObservable } from 'mobx';

import { ICallProviderPublisher } from '@gem/call/CallProviders/callProviders.types';

import { LiveKitProvider } from './LiveKitProvider';

export class LiveKitProviderPublisher implements ICallProviderPublisher {
  private root: LiveKitProvider;

  constructor(root: LiveKitProvider) {
    makeObservable(this);
    this.root = root;
  }

  @computed
  get hasAudio(): boolean {
    return this.root.hasAudio;
  }

  @computed
  get hasVideo(): boolean {
    return this.root.hasVideo;
  }

  playVideo(element: HTMLDivElement): HTMLVideoElement | null {
    if (!this.root.room) {
      return null;
    }

    const track = this.root.room.localParticipant.getTrackPublication(Track.Source.Camera)?.track;

    if (!track) {
      return null;
    }

    const video = track?.attach();
    if (video) {
      element.replaceChildren(video);
    }

    return video as HTMLVideoElement;
  }

  stopVideo(container?: HTMLVideoElement): void {
    if (!this.root.room) {
      return;
    }

    const video = this.root.room.localParticipant.getTrackPublication(Track.Source.Camera);
    if (container) {
      video?.track?.detach(container);
    } else {
      video?.track?.detach();
    }
  }
}
